'use client';

export function GTMTrackPageView() {
  window.dataLayer = window.dataLayer || [];

  window.dataLayer.push({
    appName: 'gfiber-help-center',
    pageName: window.location.pathname,
    event: 'trackPageview',
  });
}

export function GTMClickEventTrack(
  eventCategory: string,
  eventAction: string,
  eventLabel: string,
) {
  window.dataLayer = window.dataLayer || [];

  window.dataLayer.push({
    appName: 'gfiber-help-center',
    eventCategory: eventCategory,
    eventAction: eventAction,
    eventLabel: eventLabel,
    event: 'trackEvent',
  });
}

export function GTMSearchSubmitClickEventTrack(
  eventLabel: string,
  searchTerm: string,
  searchResultsCount?: string,
) {
  window.dataLayer = window.dataLayer || [];

  window.dataLayer.push({
    appName: 'gfiber-help-center',
    eventCategory: 'search',
    eventAction: 'search submitted',
    eventLabel: eventLabel,
    search_term: searchTerm,
    search_results: searchResultsCount ? searchResultsCount : undefined,
    event: 'trackEvent',
  });
}

export function GTMSearchResultClickEventTrack(
  searchTerm: string,
  searchResultsCount: string,
  title: string,
  url: string,
  position: number,
) {
  window.dataLayer = window.dataLayer || [];

  window.dataLayer.push({
    appName: 'gfiber-help-center',
    eventCategory: 'search',
    eventAction: 'search results click',
    eventLabel: 'results click',
    search_term: searchTerm,
    search_results: searchResultsCount,
    clicked_result: {
      title: title,
      url: url,
      position: position,
    },
    event: 'trackEvent',
  });
}
